import { ApiClientAxios as Axios } from "@repo/api";
import { FC } from "react";
import { formatDate, NumberToCZK } from "../../helpers";
import { useTypedTranslation } from "../../hooks";
import { usePaymentTypeFormatter } from "../Transactions/TransactionTab.helpers";
import * as Styled from "./FufiTransactionRow.styled";

export type FufiTransactionRowProps = {
    payment: Axios.FufiFinancialInfoMoneyIn;
};

export const FufiTransactionRow: FC<FufiTransactionRowProps> = ({ payment }) => {
    const { t } = useTypedTranslation();

    const formatPaymentType = usePaymentTypeFormatter();
    const title = formatPaymentType(payment.type);
    const status = t("fufi.transactions.homepageSubtitle");
    const formattedDate = payment.date ? formatDate(new Date(payment.date), "-") : "-";

    return (
        <Styled.FufiTransactionRowContainer>
            <Styled.FufiTransactionRowContent>
                <Styled.FufiTransactionRowTitle strong>{title}</Styled.FufiTransactionRowTitle>
                <Styled.FufiTransactionRowSubtitle light>
                    {`${status} ${formattedDate}`}
                </Styled.FufiTransactionRowSubtitle>
            </Styled.FufiTransactionRowContent>
            <Styled.FufiTransactionRowAmount>{NumberToCZK(payment.amount)}</Styled.FufiTransactionRowAmount>
        </Styled.FufiTransactionRowContainer>
    );
};
